import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ClosedSearchParams, ClosedSortingParams, SortField, SortOrder } from "../../Models/ClosedSearchParams";

interface ClosedFilterSortState {
    filters: ClosedSearchParams;
    sorting: ClosedSortingParams;
}

const initialState: ClosedFilterSortState = {
    filters: {
        aircraftRegistration: '',
        problemText: '',
        station: '',
        outOfServiceTimeStart: '',
        outOfServiceTimeEnd: '',
        ataCode: '',
        eventType: [],
        fleetType: ''
    },
    sorting: {
        sortBy: SortField.OTSStartTime,
        sortOrder: SortOrder.Desc,
    },
};

export const ClosedFilterSortSlice = createSlice({
    name: "closedFilterSort",
    initialState,
    reducers: {
        setFilters: (state, action: PayloadAction<ClosedSearchParams>) => {
            state.filters = action.payload;
        },
        setSorting: (state, action: PayloadAction<ClosedSortingParams>) => {
            state.sorting = action.payload;
        },
    },
});

export default ClosedFilterSortSlice;
export const { setFilters, setSorting } = ClosedFilterSortSlice.actions;
